<template>
  <AppLayout>
    <div class="home">
      <section id="warehouse-inventory">
      <div class="container" >
        <!--<div class="row">
          <div class="col-md-6">
            <h6 class="fw-bold" style="color: #000000">Inventory & Warehouse Overview</h6>
          </div>
        </div>-->

        <!-- Dashboard navigation 
        <div class="row mb-2">
          <div class="col-md-12 d-flex flex-wrap gap-2">
            <router-link
              to="/home"
              class="btn btn-sm btn-outline-primary"
            >
              Main Dashboard
            </router-link>
            <router-link
              to="/admin/procurement/analytics"
              class="btn btn-sm btn-style-2"
            >
              Procurement Dashboard
            </router-link>
          </div>
        </div>-->

        <div class="warehouse-inventory-card-wrapper" style="margin-top: 10px;">
          
          <!-- Skeleton loader for stats cards -->
          <SkeletonLoader v-if="loading" type="stats" :count="4" />
          
          <template v-else>
          <div class="warehouse-inventory-card">
            <p>No. of Stock
              Transactions Today</p>
              <strong style="font-size: 22px !important;">{{ countTodayValues(batches) }}</strong>
            <div class="total">
              <div href="#" >
                <span :class="transactionRate > 0 ? 'text-success' : 'text-danger'">{{ transactionRate}} % </span>
                <svg
                v-if="transactionRate > 0"
                class="fill-meta-3"
                width="10"
                height="11"
                viewBox="0 0 10 11"
                fill="green"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                  fill="green"
                />
              </svg>

              <svg
                  v-else
                  class="fill-meta-5"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="#FF0000"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                    fill="#FF0000"
                  />
                </svg>
                <span :class="transactionRate > 0 ? 'text-success' : 'text-danger'" > than yesterday</span>

              </div>    
            </div>
          </div>

          <div class="warehouse-inventory-card">
            <p>Dispatch Orders
              Received Today</p>
              <strong style="font-size: 22px !important;">{{  countTodayValues(dispatches) }}</strong>
            <div class="total">
              <a href="#">
                  <span :class="dispatchesRate > 0 ? 'text-success' : 'text-danger'">{{  dispatchesRate }} % </span>
                  <svg
                    v-if="dispatchesRate > 0"
                    class="fill-meta-3"
                    width="10"
                    height="11"
                    viewBox="0 0 10 11"
                    fill="green"
                    xmlns="http://www.w3.org/2000/svg"
                   >
                    <path
                      d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                      fill="green"
                    />
                  </svg>

                  <svg
                    v-else
                    class="fill-meta-5"
                    width="10"
                    height="11"
                    viewBox="0 0 10 11"
                    fill="#FF0000"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                      fill="#FF0000"
                    />
                  </svg>
                  <span :class="dispatchesRate > 0 ? 'text-success' : 'text-danger'"> than yesterday</span>
              </a>
              <!--
                <strong style="font-size: 22px !important;">{{  countTodayValues(dispatches) }}</strong>
              -->
            </div>
          </div>

          <div class="warehouse-inventory-card">
            <p>Orders
              Processed Today</p>
            <strong style="font-size: 22px !important;">{{ getTodayStats() }}</strong>
            <div class="total">
              <div>
                <span :class="ordersRate > 0 ? 'text-success' : 'text-danger'">{{ ordersRate}} % </span>
                <svg
                  v-if="ordersRate > 0"
                  class="fill-meta-3"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="green"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                    fill="green"
                  />
                </svg>

                <svg
                  v-else
                  class="fill-meta-5"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="#FF0000"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                    fill="#FF0000"
                  />
                </svg>

                <span :class="ordersRate > 0 ? 'text-success' : 'text-danger'"> than yesterday</span>

              </div>
              <!--
              <strong style="font-size: 22px !important;">{{ getTodayStats() }}</strong>
              -->
            </div>
          </div>


          


          <div class="warehouse-inventory-card">
            <p>BPN Exceptions This Month</p>
            <strong style="color: red; font-size: 22px !important;">  {{ mthExceptedBatches }} </strong>
            <div class="total">
              <a href="/transaction" class="text-sm">View more</a>
              <!--
                <div>
                <span :class="exceptionsRate > 0 ? 'text-success' : 'text-danger'">{{ exceptionsRate }} % </span>
                <svg
                  v-if="exceptionsRate > 0"
                  class="fill-meta-3"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="green"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                    fill="green"
                  />
                </svg>

                <svg
                  v-else
                  class="fill-meta-5"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="#FF0000"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                    fill="#FF0000"
                  />
                </svg>

                <span :class="exceptionsRate > 0 ? 'text-success' : 'text-danger'"> than last month</span>
              </div>
              -->
              <!--
              <strong style="color: red; font-size: 22px !important;">  {{ mthExceptedBatches }} </strong>
              -->
              
          </div>
          </div>

          <div class="warehouse-inventory-card">
            <p>POs Pending
              Approvals</p>
            <strong style="color: orange; font-size: 22px !important;">{{ unapprovedPos }}</strong>
            <div class="total">
              <a href="/purchases" class="text-sm">View more</a>
            </div>
          </div>

          <div class="warehouse-inventory-card">
            <p>Total Unverified Stocks</p>
            <strong style="color: red; font-size: 22px !important">{{ countUnverifiedStocks() }}</strong>
            <div class="total">
              <a href="/orders"  class="text-sm">View more</a>
            </div>
          </div>


          <div class="warehouse-inventory-card">
            <p>Scheduled
              Collections</p>
            <strong style="color: green; font-size: 22px !important">  {{ mthScheduledCollections }} </strong>
            <div class="total">
              <div>
                <span :class="collectionsRate > 0 ? 'text-success' : 'text-danger'">{{ collectionsRate}} % </span>
                <svg
                  v-if="collectionsRate > 0"
                  class="fill-meta-3"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="green"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                    fill="green"
                  />
                </svg>

                <svg
                  v-else
                  class="fill-meta-5"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="#FF0000"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                    fill="#FF0000"
                  />
                </svg>
                <span :class="collectionsRate > 0 ? 'text-success' : 'text-danger'"> than last month</span>
              </div>
              <!--
              <strong style="color: green; font-size: 27px !important">  {{ mthScheduledCollections }} </strong>
              -->
              
          </div>
          </div>

          <div class="warehouse-inventory-card">
            <p>Exceptions This Month</p>
            <strong style="color: red; font-size: 22px !important">  {{ mthExceptedOrders }} </strong>
            <div class="total">
              <a href="/orders" class="text-sm">View more</a>
              <!--
                   <div>
                <span :class="orderExceptionRate > 0 ? 'text-success' : 'text-danger'">{{ orderExceptionRate }} % </span>
                <svg
                  v-if="orderExceptionRate > 0"
                  class="fill-meta-3"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="green"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.35716 2.47737L0.908974 5.82987L5.0443e-07 4.94612L5 0.0848689L10 4.94612L9.09103 5.82987L5.64284 2.47737L5.64284 10.0849L4.35716 10.0849L4.35716 2.47737Z"
                    fill="green"
                  />
                </svg>

                <svg
                  v-else
                  class="fill-meta-5"
                  width="10"
                  height="11"
                  viewBox="0 0 10 11"
                  fill="#FF0000"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z"
                    fill="#FF0000"
                  />
                </svg>
                <span :class="orderExceptionRate > 0 ? 'text-success' : 'text-danger'"> than last month</span>
              </div>
              -->

              <!--
                 <strong style="color: red; font-size: 27px !important">  {{ mthExceptedOrders }} </strong>
              -->
             
             
          </div>
          </div>
          
          </template>
          
        </div>


        
          <div class="row today-order-wrapper">
              <div class="col-md-4 align-self-center" style="height: 320px !important; overflow-y:auto">
              <h6 class="fw-bold" style="color: #000000">Today’s Orders (Dispatch & Pickup Notes)</h6>
              <div class="table-wrapper">
                <div class="today-table">
                  <div class="table-card">
                    <p><b>No</b></p>
                    <p><b>Time</b></p>
                    <p><b>Note</b></p>
                    <p><b>Status</b></p>
                    <p><b>Action</b></p>
                  </div>

                  <div v-for="(pickup, index) in todaysPickup" v-bind:key="pickup.id" class="table-card">
                    <p class="text-13">{{index + 1}}</p>
                    <p class="text-13">{{this.getTime(this.formatDate(pickup.createdAt, "true"))}}</p>
                    <p class="text-13">{{pickup.pickupNo}}</p>
                    <p class="text-13" v-if="pickup.status === 'pending'"><a href="#" class="text-13 btn btn-sm btn-warning" style="border-radius: 15px">Pending</a></p>
                    <p class="text-13" v-if="pickup.status === 'cancelled'"><a href="#" class="text-13 btn btn-sm btn-danger" style="border-radius: 15px">Cancelled</a></p>
                    <p class="text-13" v-if="pickup.status === 'rejected'"><a href="#" class="text-13 btn btn-sm btn-danger" style="border-radius: 15px">Rejected</a></p>
                    <p class="text-13" v-if="pickup.status === 'active'"><a href="#" class="text-13" style="border-radius: 15px">Active</a></p>
                    <p class="text-13" v-if="pickup.status === 'approved'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Approved</a></p>
                    <p class="text-13" v-if="pickup.status === 'processed'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Processed</a></p>
                    <p class="text-13" v-if="pickup.status === 'completed'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Completed</a></p>
                    <p class="text-13" v-if="pickup.status === 'problem'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Problem</a></p>
                    <p class="text-13" v-if="pickup.status === 'resolved'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Resolved</a></p>
                    <p class="text-13"><a :href="`/orders/pickup/pdf/${pickup.id}`" class="btn-style2 small text-13">View</a></p>
                  </div>
                  <div v-for="(dispatch, index) in todaysDispatch" v-bind:key="dispatch.id" class="table-card">
                    <p class="text-13" >{{ index + todaysPickup.length + 1 }}</p>
                    <p class="text-13" >{{this.getTime(this.formatDate(dispatch.createdAt, "true"))}}</p>
                    <p class="text-13" >{{dispatch.dispatchNo}}</p>
                    <p class="text-13"  v-if="dispatch.status === 'pending'"><a href="#" class="text-13 btn btn-sm btn-warning" style="border-radius: 15px">Pending</a></p>
                    <p class="text-13"  v-if="dispatch.status === 'cancelled'"><a href="#" class="text-13 btn btn-sm btn-danger" style="border-radius: 15px">Cancelled</a></p>
                    <p class="text-13"  v-if="dispatch.status === 'active'"><a href="#" class="text-13" style="border-radius: 15px">Active</a></p>
                    <p class="text-13" v-if="dispatch.status ===  'rejected'"><a href="#" class="text-13 btn btn-sm btn-danger" style="border-radius: 15px">Rejected</a></p>
                    <p class="text-13"  v-if="dispatch.status === 'completed'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Completed</a></p>
                    <p class="text-13"  v-if="dispatch.status === 'approved'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Approved</a></p>
                    <p class="text-13" v-if="dispatch.status ===  'processed'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Processed</a></p>
                    <p class="text-13" v-if="dispatch.status ===  'problem'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Problem</a></p>
                    <p class="text-13" v-if="dispatch.status ===  'resolved'"><a href="#" class="text-13 btn btn-sm btn-success" style="border-radius: 15px">Resolved</a></p>
                    <p class="text-13" ><a :href="`/orders/dispatch/process/${dispatch.id}`" class="btn-style2 small text-13">View</a></p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 align-self-center p-4">
              <h6 class="fw-bold" style="color: #000000">Weekly Stock Movement Analysis</h6>
              <div class="line-chart" >
                <SkeletonLoader v-if="chartLoader" type="card" :count="1" />
                <LineChart 
                    v-else
                    :groupedBatches="groupedBatches"
                    :groupedOrders="groupedOrders"
                  />
              </div>
            </div>
            <div class="col-md-4 align-self-center">
              <h6 class="fw-bold" style="color: #000000">Stock Categories</h6>
              <div class="bar-chart">
                <SkeletonLoader v-if="barLoader" type="card" :count="1" />
                <BarChart
                  v-else
                  :xValues="xValues"
                  :yValues="yValues"
                />
              </div>
            </div>
          </div>
        
        <div class="system-user-manual bg-white">
          <div class="row">
            <div class="col-md-5 align-self-center">
              <h6 class="fw-bold">Transactions to monitor this month</h6>
              <ul class="lower-section">
                <li><p><strong>PO to review</strong> – {{unapprovedPos }}</p></li>
                <li><p><strong>Todays Orders</strong> – {{ getTodayStats()}} </p></li>
                <li><p><strong>Unverified Stocks</strong> – {{ countUnverifiedStocks() }} </p></li>
              </ul>
            </div>
            <div class="col-md-4 align-self-center">
              <h6 class="fw-bold">Stock Levels to monitor</h6>
              <ul class="lower-section">
                <li><p><strong class="green">Normal </strong>- {{  this.getStockLevelCount('Normal') }} items</p></li>
                <li><p><strong class="orange">Low </strong>- {{  this.getStockLevelCount('low') }} items</p></li>
                <li><p><strong class="">Re-order </strong>- {{  this.getStockLevelCount('order') }} items</p></li>
                <li><p><strong class="red">Out of Stock </strong>- {{  this.getStockLevelCount('out') }} items</p></li>
              </ul>
            </div>
            <div class="col-md-3 align-self-center">
              <div class="user-manual">
                <div class="img-wrapper">
                  <i class="fa-solid fa-circle-question"></i>
                </div>
                <h3>System user manual</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    </div>
  </AppLayout>
</template>

<script>

import AppLayout from '../components/AppLayout.vue';
import LineChart from '../components/LineChart';
import BarChart from '../components/BarChart';
import { mapGetters, mapActions } from 'vuex'
import { addArrays, countLastMonthValues, countThisMonthValues } from '@/utils/common';
import SkeletonLoader from '@/components/SkeletonLoader.vue';
import Swal from 'sweetalert2'

export default {
  name: 'HomePage',
  components: {
    AppLayout,
    LineChart,
    BarChart,
    SkeletonLoader
  },

  data(){
    return{
      token: JSON.parse(localStorage.getItem('access_token')),
      date_now: new Date().getDate()+"/"+(new Date().getUTCMonth() + 1)+"/"+new Date().getFullYear()+"  "+new Date().getHours()+":"+new Date().getMinutes(),
      url: process.env.VUE_APP_URL,
      dispatches:[],
      pickups: [],
      todaysDispatch: [],
      todaysPickup: [],
      batches: [],
      nogs: [],
      unapprovedPos: 0,
      mthScheduledCollections: 0,
      collectionsRate: 0,
      exceptionsRate: 0,
      mthExceptedBatches: 0,
      mthExceptedOrders:0, 
      orderExceptionRate:0,
      groupedPickups: [], 
      groupedDispatches: [],
      groupedBatches: [],
      groupedOrders: [],
      weekDispatches: [],
      weekPickups: [],
      weekBatches: [],
      purchases: [],
      dispatchesRate:0.0, 
      ordersRate:0.0,
      transactionRate:0.0,
      activities: [],
      products: [],
      results: [],
      xValues: [],
      yValues: [],
      chartLoader: false,
      barLoader: false,
      loading: false
    }
  },

  computed:{
        ... mapGetters (["getCategories", "getWarehouses", "getProductOptions", "getProfile"]),
        categories () { return this.getCategories },
        warehouses () { return this.getWarehouses },
        profile() { return this.getProfile}
    },

  mounted(){
    this.setupPickups()
    this.getProducts()
    this.getActivities()
    this.getPurchases()
    this.setUpNogs()
    this.setupBatches()
    this.fetchCategories()
    //this.fetchProfile()   
  },



  methods: {
    getDayRange(dayOffset = 0) {
      const base = new Date()
      base.setDate(base.getDate() + dayOffset)
      const start = new Date(base)
      start.setHours(0, 0, 0, 0)
      const end = new Date(base)
      end.setHours(23, 59, 59, 999)
      return { start, end }
    },

    getRecordDate(obj) {
      const candidates = [
        obj?.createdAt,
        obj?.dateIssued,
        obj?.issuedAt,
        obj?.date,
        obj?.created_at,
        obj?.updatedAt,
      ]
      for (const raw of candidates) {
        if (!raw) continue
        const d = new Date(raw)
        if (!Number.isNaN(d.getTime())) return d
      }
      return null
    },

    ... mapActions(['fetchNogs', 'fetchCategories', 'fetchProfile']),
    
    getTime(inputString) {
      const parts = inputString.split('-');
      return parts.length > 1 ? parts[1].trim() : '';
    },

    async setupBatches(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        try{
            this.loading = true
            const res = await fetch(process.env.VUE_APP_URL+'/batches', requestOptions)
            const data = await res.json()
            // API may return either a plain array or a wrapped object { status, batches / data }
            this.batches = Array.isArray(data)
              ? data
              : (data.batches || data.data || [])

            this.weekBatches = this.filterByCurrentWeek(this.batches)
            this.groupedBatches =  this.groupByDayOfWeek(this.weekBatches)
           // console.log("Week Batches",this.weekBatches)
           // console.log("Grouped Batches", this.groupedBatches)
            
            const exceptedBatches = this.batches.filter(item => item.exception === true);
            
            const mthExceptedBatches = countThisMonthValues(exceptedBatches)
            this.mthExceptedBatches = mthExceptedBatches
            const lastMthExceptedBatches =  countLastMonthValues(exceptedBatches)
            this.exceptionsRate =  Math.round(this.calculateRate(mthExceptedBatches,lastMthExceptedBatches))
          
            
            const todayBatches = this.countTodayValues(this.batches)
            const yesterdayBatches = this.countYesterdayValues(this.batches)
            this.transactionRate =  Math.round(this.calculateRate(todayBatches,yesterdayBatches))
            
        }catch(err){
            console.log(err)
        }finally{
            this.loading = false
        }
    },


    getProcessedOrders(orders) {
      const processedStatuses = ['completed', 'processed', 'approved'];
      return (orders || []).filter(o => {
        const s = (o.status || '').toString().toLowerCase();
        return processedStatuses.includes(s);
      });
    },

    async setUpNogs () {
      const headers = { 'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('access_token'))}
      const res = await fetch(process.env.VUE_APP_URL+'/nogs',{ mode: 'cors', headers})
      this.nogs = await res.json()
    },

     async setupPickups(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/pickups/dashboard', requestOptions)
        const data = await res.json()
        this.pickups = Array.isArray(data) ? data : (data.pickups || data.data || [])

        this.todaysPickup = this.getTodayValues(this.pickups)
        const scheduledCollections = this.pickups.filter(obj => obj.scheduled === 1);

        this.weekPickups = this.filterByCurrentWeek(this.pickups)
        this.groupedPickups =  this.groupByDayOfWeek(this.weekPickups)

        const thisMthCollections = countThisMonthValues(scheduledCollections)
        this.mthScheduledCollections = thisMthCollections
        const lastMthCollections = countLastMonthValues(scheduledCollections)

        this.collectionsRate = Math.round(this.calculateRate(thisMthCollections,lastMthCollections))
        this.setupDispatches()
      },


      async getPurchases () {
          const requestOptions = {
              method: "GET",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          };
          const res = await fetch(process.env.VUE_APP_URL+'/purchases/dashboard', requestOptions)
          const data = await res.json()
            if(data.status == true){
               this.purchases = data.purchases
               this.countUnapprovedPos()
              // console.log(this.purchases)
            }else{
               //console.log(data.message)
            }
      },


      countUnverifiedStocks(){
        const unverifiedPickups = this.pickups.filter(obj => obj.status === 'active');
        const unverifiedDispatches = this.dispatches.filter(obj => obj.status === 'active');
        return unverifiedPickups.length + unverifiedDispatches.length
      },


      countUnapprovedPos() {
        // Treat any non-final PO status as "pending approval"
        const preApprovalStatuses = ['pending', 'approved', 'verified', 'stamped', 'active'];
        this.unapprovedPos = (this.purchases || []).filter(p => {
          const s = (p.status || '').toString().toLowerCase();
          return preApprovalStatuses.includes(s);
        }).length;
      },

      async setupDispatches(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };

        try {
          this.chartLoader = true
          const res = await fetch(process.env.VUE_APP_URL + '/dispatches/dashboard', requestOptions);
          const data = await res.json();
          this.dispatches = Array.isArray(data) ? data : (data.dispatches || data.data || [])
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching the dispatches.',
          });
          this.chartLoader = false
        } finally {
          this.chartLoader = false
        }
                

        this.todaysDispatch= this.getTodayValues(this.dispatches)
        const todayDispatches = this.countTodayValues(this.dispatches)
        const yesterdayDispatches = this.countYesterdayValues(this.dispatches)
        

        this.dispatchesRate = Math.round(this.calculateRate(todayDispatches,yesterdayDispatches))
      
        const todayOrders = this.countTodayValues(this.getProcessedOrders(this.dispatches)) + this.countTodayValues(this.getProcessedOrders(this.pickups))
        const yesterdayOrders = this.countYesterdayValues(this.getProcessedOrders(this.dispatches)) + this.countYesterdayValues(this.getProcessedOrders(this.pickups))
        this.ordersRate =  Math.round(this.calculateRate(todayOrders,yesterdayOrders))

        this.weekDispatches =  this.filterByCurrentWeek(this.dispatches)
        this.groupedDispatches = this.groupByDayOfWeek(this.weekDispatches)
        this.groupedOrders = addArrays(this.groupedPickups, this.groupedDispatches)
       
        const exceptedPickups = this.pickups.filter(item => item.exception == 1 || item.exception === true);
        const exceptedDispatches = this.dispatches.filter(item => item.exception == 1 || item.exception === true);
            
        const mthExceptedPickups = countThisMonthValues(exceptedPickups)
        const mthExceptedDispatches = countThisMonthValues(exceptedDispatches)

        const lastMthExceptedPickups =  countLastMonthValues(exceptedPickups)
        const lastMthExceptedDispatches =  countLastMonthValues(exceptedDispatches)

        const mthExceptedOrders = mthExceptedDispatches + mthExceptedPickups
        const lastMthExceptedOrders = lastMthExceptedDispatches + lastMthExceptedPickups

        this.mthExceptedOrders = mthExceptedOrders
        this.orderExceptionRate = Math.round(this.calculateRate(mthExceptedOrders, lastMthExceptedOrders))


            
      },
   

      /** Percent change vs previous period; avoids ÷0 and bogus -Infinity when baseline is 0 */
      calculateRate(current, previous) {
        const cur = Number(current) || 0
        const prev = Number(previous) || 0
        if (cur === prev) return 0
        if (prev === 0) return cur > 0 ? 100 : 0
        return Math.round(((cur - prev) / prev) * 100)
      },

      getTodayStats(){
        return this.countTodayValues(this.getProcessedOrders(this.dispatches)) + this.countTodayValues(this.getProcessedOrders(this.pickups))
      },


      getYesterdayStats(){
        return this.countYesterdayValues(this.dispatches) + this.countYesterdayValues(this.pickups)
      },

      isInCurrentWeek(date) {
        const now = new Date();
        const currentDay = now.getDay(); // 0=Sun ... 6=Sat
        const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay; // week starts Monday
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() + mondayOffset);
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        
        startOfWeek.setHours(0, 0, 0, 0);
        endOfWeek.setHours(23, 59, 59, 999);
        
        return date >= startOfWeek && date <= endOfWeek;
      },

      filterByCurrentWeek(data) {
          const currentWeekData = data.filter(item => {
              const createdAt = this.getRecordDate(item);
              return createdAt ? this.isInCurrentWeek(createdAt) : false;
          });
          return currentWeekData;
      },


      groupByCategory() {
        const grouped = {};
        this.products.forEach(obj => {
            const category = obj?.Category?.category;
            if (!grouped[category]) {
                grouped[category] = 0;
            }
            grouped[category]++;
        });
        const result = Object.entries(grouped).map(([category, count]) => ({
            category,
            count
        }));
        
        return result;
      },

    
      groupByDayOfWeek(array) {
        const counts = [0, 0, 0, 0, 0, 0, 0]
        array.forEach(item => {
          const dayOfWeek = new Date(item.createdAt).getDay();
          counts[dayOfWeek]++;
        });
        const result = [];
        for (let i = 1; i <= 7; i++) {
          const dayIndex = (i + 5) % 7;
          result.push(counts[dayIndex] || 0);
        }
        return result;
    },


    async getProducts (){
        const requestOptions = {
          method: "GET",
          headers: { "Content-Type": "application/json", 'Authorization': 'Bearer ' + this.token},
        };
        try {
          this.barLoader = true
          const res = await fetch(process.env.VUE_APP_URL + '/products', requestOptions);
          const data = await res.json();
          this.products = Array.isArray(data) ? data : (data.products || data.data || []);
          this.results = this.groupByCategory();
          this.xValues = this.results.map(obj => obj.category);
          this.yValues = this.results.map(obj => obj.count);
        } catch (error) {
          this.barLoader = false
        }finally{
          this.barLoader = false
        }
      
     },

      async getActivities () {
          const requestOptions = {
              method: "GET",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          };
          const res = await fetch(process.env.VUE_APP_URL+'/inventory/activity', requestOptions)
          const data = await res.json()
          if(data.status == true){
              this.activities = data.activities
          }
      },


      getStockLevelCount(stock) {
        const stockLowerCase = stock.toLowerCase()
        let count = 0

        for (const obj of this.activities) {
            const objStockLowerCase = obj.stock.toLowerCase()
            if (objStockLowerCase === stockLowerCase) {
                count++;
            }
        }
        return count;
      },


      countTodayUpdatedValues(array) {
        const { start, end } = this.getDayRange(0)
        const todayValues = array.filter(obj => {
            const createdAtDate = obj?.updatedAt ? new Date(obj.updatedAt) : null
            return createdAtDate && !Number.isNaN(createdAtDate.getTime()) && createdAtDate >= start && createdAtDate <= end
        });
        return todayValues.length;
      },

      countYesterdayUpdatedValues(array) {
        const { start, end } = this.getDayRange(-1)
        const yesterdayValues = array.filter(obj => {
            const createdAtDate = obj?.updatedAt ? new Date(obj.updatedAt) : null
            return createdAtDate && !Number.isNaN(createdAtDate.getTime()) && createdAtDate >= start && createdAtDate <= end
        });
        return yesterdayValues.length;
      },

      countTodayValues(array) {
        const { start, end } = this.getDayRange(0)
        const todayValues = array.filter(obj => {
            const createdAtDate = this.getRecordDate(obj)
            return createdAtDate && createdAtDate >= start && createdAtDate <= end
        });
        return todayValues.length;
      },
      
      getTodayValues(array) {
        const { start, end } = this.getDayRange(0)
        const todayValues = array.filter(obj => {
            const createdAtDate = this.getRecordDate(obj)
            return createdAtDate && createdAtDate >= start && createdAtDate <= end
        });
        return todayValues;
      },

      countYesterdayValues(array) {
        const { start, end } = this.getDayRange(-1)
        const yesterdayValues = array.filter(obj => {
            const createdAtDate = this.getRecordDate(obj)
            return createdAtDate && createdAtDate >= start && createdAtDate <= end
        });
        return yesterdayValues.length;
      },

      countVerifiedPickups() {
        let count = 0;
        for (const obj of this.pickups) {
          if (!obj.isVerified) {
            count++;
          }
        }

        return count;
      }
  }
}
</script>